import Issue from "./Issue";
import Milestone from "./Milestone";
import Project from "./Project";
import TaskColor from "./Task";

const StatusTab = () => {
  return (
    <div className=" row p-4">
      <div className="col-lg-6">
        <Project />
      </div>
      <div className="col-lg-6">
        <TaskColor />
      </div>
      <div className="col-lg-6">
        <Issue />
      </div>
      <div className="col-lg-6">
        <Milestone />
      </div>
    </div>
  );
};
export default StatusTab;
